import * as KeyBindings from './KeyBindings.js'

export const Commands = {
  'KeyBindings.hydrate': KeyBindings.hydrate,
  // Command.register(756, KeyBindings.setKeyBindings)
}
